module.exports = __webpack_public_path__ + "img/invoiceUploadV2SuccessFromEit.21385222.png";